import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  @Input() part: any

  title: string = 'My first AGM project';
  lat: number = 59.8152245
  lng: number = 10.4308032
  zoom: number = 13;

  model = <any>{ }

  constructor() { }

  ngOnInit() {
console.log('-- contact component --')
console.log(this.part)
  }

  submit() {
console.log('-- submit form --')
  }
}
